import { useTranslation } from '../../../contexts/TranslationContext';
import {
    Checkbox,
    FormControl,
    FormControlLabel,
    FormHelperText,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FormFieldProps } from './index';
import { useFormErrors } from '../../../contexts/FormContext';
import React from 'react';

export default function CheckboxFormField({
    type,
    name,
    label,
    value,
    required,
    disabled,
    onChange,
    cssClassName,
    help,
}: FormFieldProps) {
    const theme = useTheme();
    const { translate } = useTranslation();

    const { error } = useFormErrors(name);

    return (
        <FormControl className={cssClassName} error={Boolean(error)}>
            <FormControlLabel
                sx={{ color: theme.palette.text.secondary }}
                control={
                    <Checkbox
                        checked={Boolean(value)}
                        name={name}
                        sx={{
                            py: 0,
                            color: error ? theme.palette.error.main : undefined,
                        }}
                        onChange={(event, val) => onChange(val)}
                    />
                }
                label={translate(label)}
            />
            {Boolean(error && typeof error === 'string') && (
                <FormHelperText error id={`${name}-error`} sx={{ mx: 0 }}>
                    {translate(error ?? 'error')}
                </FormHelperText>
            )}
        </FormControl>
    );
}
